module.exports = "./img/d7fb1a7b82289b3f78ad0112b4920be8.jpg";